// extracted by mini-css-extract-plugin
export var black = "RadioColor_black__HP6ex";
export var explanation = "RadioColor_explanation__c07q8";
export var md = "768px";
export var radioColorContainer = "RadioColor_radioColorContainer__6Cjmn";
export var radioColorInput = "RadioColor_radioColorInput__jUZk-";
export var shared = "'../../../shared.module.css'";
export var white = "RadioColor_white__fBJxv";